'use client'
import { createUserProfileFromSdkUser } from '../../../../utils/functions/createUserProfile/createUserProfile.js';
import { getUser, setUser } from '../user.js';
import { storeAuthToken } from '../../../../utils/functions/storeAuthToken/storeAuthToken.js';
import { getProjectSettings } from '../../projectSettings/projectSettings.js';

const storeAuthTokenAndUser = (params) => {
    storeAuthToken(params);
    const userProfile = createUserProfileFromSdkUser(params.user);
    if (params.preserveFieldsWithVerification) {
        const oldUser = getUser();
        const settings = getProjectSettings();
        if (settings === null || settings === void 0 ? void 0 : settings.kyc) {
            for (const field of settings.kyc) {
                if (!field.verify)
                    continue;
                const property = field.name;
                // @ts-expect-error TS doesn't know that the property exists
                userProfile[property] = oldUser === null || oldUser === void 0 ? void 0 : oldUser[property];
            }
        }
    }
    setUser(userProfile);
    return userProfile;
};

export { storeAuthTokenAndUser };
